exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon-dot3{width:14px;height:14px;position:relative;display:inline-block;cursor:pointer}.icon-dot3:after{content:\"\";position:absolute;margin:auto;top:0;bottom:0;right:0;left:0;width:2px;height:2px;background-color:#999;background-color:var(--color-font-3);box-shadow:-6px 0 #999,6px 0 #999;box-shadow:-6px 0 var(--color-font-3),6px 0 var(--color-font-3)}", ""]);

// exports
